<div class="modal-header">
  <h4 class="modal-title header-13"> {{ getTitle() }} </h4>
  <button
    type="button"
    class="accello-icon-btn"
    (mousedown)="isActive = true"
    (mouseup)="isActive = false"
    (mouseleave)="isActive = false"
    (click)="activeModal.dismiss('Cross click')"
  >
    <img
      [src]="
        isActive
          ? 'assets/images/virtusa-icons/close-dark.svg'
          : 'assets/images/virtusa-icons/close.svg'
      "
    />
  </button>
</div>

<!-- WEB -->
<div
  class="modal-body p-4 pt-1 m-0 w-100 d-flex activities-content"
  *ngIf="(type === 'web') && !displayProgress"
>
  <div class="d-flex w-100 align-items-center">

    <!-- Right panel -->
    <div
      class="detailed-wrap h-100 d-flex flex-column"
      [ngClass]="{ 'shadow p-4 card-type': !isDataLoaded }"
    >
      <div class="user-info">
        <div class="alert alert-primary p-2 px-3" role="alert">
          ** Validation is mandatory before loading recorded activities in the
          code view to ensure everything functions correctly.
        </div>
      </div>
      <div class="table-wrap overflow-auto">
        <div class="table-container h-100">
          <div class="w-50 h-100 mx-auto v-center">
            <div class="v-center p-4 field-content">
              <input
                [(ngModel)]="extentionId"
                type="text"
                class="form-control mt-4 mb-2 p-2 px-3"
                placeholder="Enter extension ID here"
              />
              <button
                class="btn-accello-primary text-center"
                [disabled]="isLoading || !extentionId"
                (click)="loadRecordedActivities()"
              >
                Load Activities
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- AI -->
<div class="modal-body ai-content" *ngIf="type == 'ai' && !displayProgress">
  @if(displayLoader) {
  <app-loading></app-loading>
  } @else {
  <div class="mapped-case mb-3">
    <span class="form-label">Mapped test case</span>
    <div class="form-control-static">{{ model.testCase }}</div>
  </div>

  <div class="two-col-grid mb-3">
    <div class="form-field">
      <label class="form-label" for="ai-app-name">
        Application Name<span class="text-danger">*</span>
      </label>
      <div class="ai-select-wrapper">
        <select
          id="ai-app-name"
          class="ai-select"
          [(ngModel)]="model.appName"
          (ngModelChange)="onApplicationChange()"
        >
          <option [ngValue]="''" disabled>Select application name</option>
          <option
            *ngFor="let opt of getApplicationOptions()"
            [ngValue]="opt.id || opt.value"
          >
            {{ opt.name || opt.label }}
          </option>
        </select>
        <img
          class="ai-select-arrow"
          src="assets/images/virtusa-icons/drop-arrow.svg"
          alt=""
          aria-hidden="true"
          width="12"
          height="8"
        />
      </div>
    </div>

    <div class="form-field">
      <label class="form-label" for="ai-base-url">
        Base URL<span class="text-danger">*</span>
      </label>
      <div class="ai-input-wrapper" [attr.aria-busy]="isAppDetailsLoading">
        <input
          id="ai-base-url"
          type="text"
          class="form-control ai-input"
          [placeholder]="isAppDetailsLoading ? 'Fetching base URL…' : 'Add Base URL'"
          [disabled]="isAppDetailsLoading"
          [(ngModel)]="model.baseUrl"
          (ngModelChange)="onBaseUrlChange()"
          aria-describedby="ai-base-url-helper"
        />
        <span
          *ngIf="isAppDetailsLoading"
          class="spinner-border spinner-border-sm ai-input-spinner"
          aria-hidden="true"
        ></span>
      </div>
      <div id="ai-base-url-helper" class="ai-field-helper" aria-live="polite">
        @if (isAppDetailsLoading) {
          Loading application details…
        } @else if (appDetailsError) {
          <span class="ai-field-helper--error">{{ appDetailsError }} Enter the Base URL manually or</span>
          <button type="button" class="ai-field-helper-link" (click)="retryApplicationDetails()">Retry</button>
        } @else if (autoFilledFromApp) {
          Auto-filled from {{ autoFilledFromApp }}. You can edit it.
        }
      </div>
    </div>
  </div>

  <div class="credentials-header d-flex justify-content-between align-items-center mb-2">
    <span class="section-title">File Connection(s)</span>
    <div class="d-flex align-items-center gap-3">
      <button
        *ngIf="!showAddConnectionForm"
        type="button"
        class="add-connection-link"
        (click)="openAddConnectionForm()"
      >
        Add New Connection
      </button>
      <button type="button" class="add-credential-link" (click)="addConnectionRow()">
        Add Connection
      </button>
    </div>
  </div>

  <div class="ai-inline-connection-form mb-3" *ngIf="showAddConnectionForm">
    <div class="ai-inline-form-header">
      <span class="ai-inline-form-title">Add New Storage Connection</span>
      <div class="ai-inline-form-actions">
        <button
          type="button"
          class="ai-inline-save"
          [disabled]="!storageConnectionForm?.canSubmit || isSavingConnection"
          (click)="saveInlineConnection()"
          aria-label="Save connection"
        >
          <span
            *ngIf="isSavingConnection"
            class="spinner-border spinner-border-sm"
            aria-hidden="true"
          ></span>
          <mat-icon *ngIf="!isSavingConnection">check</mat-icon>
        </button>
        <button
          type="button"
          class="ai-inline-cancel"
          [disabled]="isSavingConnection"
          (click)="cancelAddConnectionForm()"
          aria-label="Cancel"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <app-formly-modal
      *ngFor="let key of [storageFormRenderKey]"
      #storageConnectionForm
      [embedded]="true"
      [hideFooter]="true"
      [configs]="storageConnectionConfigs"
      [fields]="storageConnectionFields"
      (saved)="onStorageConnectionSaved($event)"
      (cancelled)="cancelAddConnectionForm()"
    ></app-formly-modal>
  </div>

  <div class="connection-remarks mb-3">
    <app-zorro-table
      tableId="vr-connection-remarks"
      class="w-100"
      [columns]="connectionRemarksColumns"
      [data]="selectedConnections"
      [options]="{ showPagination: false }"
      (handleActions)="handleConnectionTableActions($event)"
    ></app-zorro-table>
  </div>

  <div class="credentials-header d-flex justify-content-between align-items-center mb-2">
    <span class="section-title">Role-Based Credential(s)</span>
    <button
      type="button"
      class="add-credential-link"
      [disabled]="isAppDetailsLoading"
      (click)="onButtonClick()"
    >
      Add Credential(s)
    </button>
  </div>

  <app-zorro-table
    tableId="vr-dt-2"
    class="w-100"
    [columns]="tableData.columns"
    [data]="tableData.rows"
    [isLoading]="isAppDetailsLoading"
    [attr.aria-busy]="isAppDetailsLoading"
    (handleActions)="handleTableActions($event)"
  ></app-zorro-table>
  }
</div>

<!-- API -->
<div
  class="modal-body api-content"
  *ngIf="type == 'api' && !displayProgress && !showResult"
>
  <div class="two-col-grid mb-3">
    <div>
      <span class="form-label">Script name</span>
      <div class="form-control-static">{{ model.scriptName }}</div>
    </div>
    <div>
      <span class="form-label">Test suite</span>
      <div class="form-control-static">{{ model.testSuiteName }}</div>
    </div>
  </div>

  <div class="mb-3">
    <span class="form-label">Mapped test case</span>
    <div class="form-control-static">{{ model.testCase }}</div>
  </div>

  <div class="mb-4">
    <span class="form-label">Swagger file<span class="text-danger">*</span></span>
    <div
      class="file-upload-area"
      [class.drag-over]="isDragOver"
      (drop)="onDrop($event)"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
    >
      <div class="upload-icon">
        <img src="assets/images/virtusa-icons/upload-light.svg" alt="upload" />
      </div>
      <div class="upload-text">
        Drag & drop your file here or
        <label class="file-chooser">
          Choose file
          <input
            type="file"
            accept=".json,.yaml,.yml"
            (change)="onFileSelected($event)"
            hidden
          />
        </label>
      </div>
      <div class="file-type-hint">Only .json / .yaml</div>
      <div class="selected-file" *ngIf="selectedFile">
        <i class="ri-file-line"></i> {{ selectedFile.name }}
      </div>
    </div>
  </div>
</div>

<!-- Mobile -->
<div
  class="modal-body mobile-content"
  *ngIf="type == 'mobile' && !displayProgress && !showResult"
>
  <div class="d-flex">
    <span class="title-fnt"> Mapped Test Case </span>
    <span> {{ model.testCase }} </span>
  </div>
  <div class="inputs-wrap">
    <div class="mobile-inp">
      <span> Application Name </span>
      <select class="form-select" [(ngModel)]="mobileData.application">
        <option *ngFor="let app of getApps()" [value]="app.value">
          {{ app.label }}
        </option>
      </select>
    </div>
    <div *ngIf="!getFilteredDevices()?.length" class="mb-2 d-flex flex-column no-device-msg">
      <strong> Let's setup a mobile device first. </strong>
      <span> Please add a mobile device before continuing. You can do this by going to Execution > Devices </span>
    </div>
    <div class="mobile-inp">
      <span> Device </span>
      <select class="form-select" [(ngModel)]="mobileData.device" [disabled]="!getFilteredDevices()?.length">
        <option *ngFor="let device of getFilteredDevices()" [value]="device.value">
          {{ device.label }}
        </option>
      </select>
    </div>
    <div class="mobile-inp mb-3">
      <span> Role-Based Credentials </span>
      <div class="d-flex w-100">
        <div class="add-cred" (click)="onButtonClick()" (keydown)="onButtonClick()">
          <img src="assets/images/virtusa-icons/add-icon.svg" alt="add" />
          <strong class="mx-1"> Add new credential </strong>
        </div>
      </div>
    </div>
  </div>

  <div class="mobile-table-wrap">
    <app-zorro-table
      tableId="vr-dt-3"
      class="w-100"
      [columns]="tableData.columns"
      [data]="tableData.rows"
      (handleActions)="handleTableActions($event)"
    ></app-zorro-table>
  </div>
</div>

<div *ngIf="displayProgress" class="prg-wrap" [class.has-logs]="processLogsDefined" [class.prg-wrap--media]="isManualScriptGeneration">
  <div class="process-error-banner mx-4 mb-3" *ngIf="progressStatus.isError && progressStatus.text">
    <span class="process-error-label">Action Required:</span>
    <span class="process-error-message">{{ progressStatus.text }}</span>
  </div>

  <div class="manual-run" *ngIf="isManualScriptGeneration">
    <div class="recording-stage">
      <img *ngIf="recordingUrl" [src]="recordingUrl" (load)="releasePreviousRecording()" alt="Recording" />
      <div class="recording-empty" *ngIf="!recordingUrl">Waiting for the recording...</div>
    </div>
    <app-process-logs-loader
      [logs]="processLogsDefined ? processLogs : undefined"
      [statusLabel]="processStatusLabel"
      [isActive]="isProcessActive"
      [isError]="progressStatus.isError"
      [showLoader]="true"
    ></app-process-logs-loader>
  </div>

  <app-process-logs-loader
    *ngIf="!isManualScriptGeneration"
    class="w-100 px-4 pb-4"
    [logs]="processLogsDefined ? processLogs : undefined"
    [statusLabel]="processStatusLabel"
    [isActive]="isProcessActive"
    [isError]="progressStatus.isError"
    [showLoader]="true"
  ></app-process-logs-loader>
</div>

<div
  class="modal-footer manual-footer"
  *ngIf="displayProgress && isManualScriptGeneration && (isProcessActive || progressStatus.isError)"
>
  <div class="d-flex justify-content-end w-100">
    <button
      type="button"
      class="btn-accello-secondary open-btn"
      (click)="cancelEventStream()"
    >
      Cancel
    </button>
  </div>
</div>

<div
  class="modal-footer"
  *ngIf="(type == 'ai' || type === 'api' || type === 'mobile') && !showResult && !displayProgress"
>
  <div class="d-flex justify-content-end">
    <button
      class="btn-accello-secondary mx-2 open-btn"
      (click)="activeModal.dismiss('Cross click')"
    >
      Cancel
    </button>
    <button
      class="btn-accello-primary-light open-btn"
      (click)="loadActivities()"
      [disabled]="isButtonDisabled()"
    >
      {{ isGeneratingScripts ? 'Starting' : (type === 'ai' ? 'Generate' : 'Generate Scripts') }}
    </button>
  </div>
</div>
